import { RectLayout } from "../../GeometricLayout";
import { TreeRange } from "../../writeshift/Range";

export default function treeRangeToOverlayPosition(
  treeRange: TreeRange,
  rootNode: Node,
  { scrollTop, scrollLeft }: { scrollTop: number; scrollLeft: number },
  { top, left }: { top: number; left: number }
): RectLayout[] | null {
  const { start, end } = treeRange;

  const range = new Range();
  let current = rootNode;
  for (const i of start.index) {
    if (!current) {
      return null;
    }
    current = current.childNodes.item(i);
  }
  if (current !== null) {
    if (start.offset <= current!.textContent!.length) {
      range.setStart(current, start.offset);
    }
  }
  current = rootNode;
  for (const i of end.index) {
    if (!current) {
      return null;
    }
    current = current.childNodes.item(i);
  }
  if (current !== null) {
    if (end.offset <= current!.textContent!.length) {
      range.setEnd(current, end.offset);
    }
  }
  /* TODO: find the minimal set of rects per line.
   * Currently, the client rects are split by any
   * tag changes.
   * e.g.
   *     `<p>Hell<b>o</b> world</p>`
   * If that all is underlined, there would be three client rects,
   * even if it's laid out on one line. We only want to break out rects
   * if there's a line break.
   */
  const rects = Array.from(range.getClientRects());

  return rects.map((rect) => ({
    height: rect.height,
    width: rect.width,
    top: rect.top + scrollTop - top,
    left: rect.left + scrollLeft - left,
  }));
}
